import React, { useState } from "react";
import axios from "axios";
import Sign from "../components/Sign";

const SignUp = () => {
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [type, setType] = useState("signup");
    const [email, setEmail] = useState("");

    const handleSignUp = async e => {
        setErrorMessage("")
        if (e.password !== e.retype_password) {
            setErrorMessage("Passwords do not match")
            return;
        }
        setLoading(true);

        try {
            await axios
                .post(
                    "/auditor/business/account/signup",
                    {
                        email: e.email,
                        password: e.password
                    }
                );
            setEmail(e.email)
            setType("signup_success")
        } catch (error) {
            setLoading(false);
        }
    }

    return (
        <Sign
            // new auditor
            title="Auditor Sign Up"
            type={type}
            formComplete={handleSignUp}
            errorMessage={errorMessage}
            loading={loading}
            email={email}
        />
    );
}

export default SignUp;
